import { reject, assign } from 'lodash/fp';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';

export default (attendances = [], action) => {
  switch (action.type) {
    case IN_PERSON_TRAINING.ATTENDANCES.CREATE:
      return [
        ...action.attendances.map(assign({ dateAdded: Date.now() })),
        ...attendances,
      ];

    case IN_PERSON_TRAINING.ATTENDANCES.REMOVE:
      return reject({ id: action.attendance.id })(attendances);

    default:
      return attendances;
  }
};
